import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sorterBy',
  pure: true
})
export class SorterPipe implements PipeTransform {

  transform(array: any[] | null, field: string, direction: 'ASC' | 'DESC' = 'ASC'): any[] {
    if (!array || !field) {
      return array;
    }
    const sortedArray = [...array];
    sortedArray.sort((a: any, b: any) => {
      const valA = typeof a[field] === 'string' ? a[field].toLowerCase() : a[field];
      const valB = typeof b[field] === 'string' ? b[field].toLowerCase() : b[field];

      if (valA < valB) {
        return direction === 'ASC' ? -1 : 1;
      }
      if (valA > valB) {
        return direction === 'ASC' ? 1 : -1;
      }
      return 0;
    });
    return sortedArray;
  }
}
